import { type MultiselectAccountValue } from "../../UserAccounts/DropdownWithMultiselect/DropdownWithMultiSelect";

export const selectedOrderQuoteAccountDropdown = (list: MultiselectAccountValue[]) =>
  list
    .filter((account) => account.isChecked)
    .map((item) => item.value)
    .join(",");
